<mat-form-field appearance="fill" color="primary" class="w-100">
  @if (control?.hasLabel) {
    <mat-label [style.color]="control.labelColour">{{control.label}}</mat-label>
  }
  <input matInput [matDatepicker]="picker" placeholder="{{control?.placeHolder}}" [(ngModel)]="value" (ngModelChange)="onValueChanges($event)" />
  <mat-datepicker  #picker></mat-datepicker>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
</mat-form-field>
